export default {
  fullscreen: 'Pantalla completa',
  exitFullscreen: 'Salir de pantalla completa'
}
